import { useLanguage } from "@/i18n/LanguageContext";

export default function OurScopeSection() {
  const { t } = useLanguage();

  const weDoItems = t("home.scopeDoItems") as unknown as string[];
  const weReferItems = t("home.scopeDontItems") as unknown as string[];

  return (
    <section className="w-full bg-[#fefce8] py-20">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-4">
            {t("home.scopeTitle")}
          </h2>
          <p className="text-sm md:text-base text-[#374151] max-w-[720px] mx-auto">
            {t("home.scopeIntro")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          {/* What We Do */}
          <div>
            <h3 className="text-lg md:text-2xl font-bold text-primary mb-5">
              {t("home.scopeDo")}
            </h3>
            <ul className="space-y-3">
              {weDoItems.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm md:text-base text-secondary">
                  <i className="ri-checkbox-circle-fill text-primary mt-0.5 text-lg shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* What We Refer Out */}
          <div>
            <h3 className="text-lg md:text-2xl font-bold text-[#ea580c] mb-5">
              {t("home.scopeDont")}
            </h3>
            <ul className="space-y-3">
              {weReferItems.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm md:text-base text-secondary">
                  <i className="ri-arrow-right-circle-fill text-[#ea580c] mt-0.5 text-lg shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="text-center text-sm text-[#374151] italic mt-10 max-w-[720px] mx-auto">
          {t("home.scopeReferText")}
        </p>
      </div>
    </section>
  );
}